import * as React from "react";
import { useHistory } from "react-router";
import styled from "styled-components";

import { CommissionParitaireApi, CommissionParitaireGridDto, CommissionParitaireSearchDto } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { EditButton, SearchTablePage, ViewButton } from "../../../../../components";
import { useAbortableApiServiceFactory, useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

interface ICommissionParitaireListPageProps {}

const Container = styled.div`
  display: flex;
`;

export const CommissionParitaireListPage: React.FunctionComponent<ICommissionParitaireListPageProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(CommissionParitaireApi);

  const columns = React.useMemo(
    () => [
      {
        computed: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: CommissionParitaireGridDto) => (
          <Container>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.commissionParitaire}/${row.idcommissionParitaire}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.commissionParitaire}/${row.idcommissionParitaire}/detail/edit`)}
            />
          </Container>
        )
      },
      {
        header: () => t(ETLCodes.Code),
        fieldName: "code"
      },
      {
        header: () => t(ETLCodes.Libelle),
        fieldName: "libelle"
      }
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => history.push(`${ERoutes.commissionParitaire}/0/detail/edit`), [
    history
  ]);

  const getCriteriasFn = React.useCallback(
    () => api.commissionParitaireGetSearchCriterias({ includeListsValues: true }),
    [api]
  );

  const apiFactory = useAbortableApiServiceFactory(CommissionParitaireApi);
  const lastAbortController = React.useRef<AbortController>();
  const searchFn = React.useCallback(
    (nextSearch?: CommissionParitaireSearchDto) => {
      const { api: abortableApi, abortController } = apiFactory();
      lastAbortController.current = abortController;
      return abortableApi.commissionParitaireBaseSearch({ CommissionParitaireSearchDto: nextSearch });
    },
    [apiFactory]
  );

  const onAbort = React.useCallback(() => lastAbortController.current?.abort(), []);

  return (
    <SearchTablePage
      sortKeys={{ code: "ASC" }}
      columns={columns}
      getCriteriasFunction={getCriteriasFn}
      searchFunction={searchFn}
      onAbort={onAbort}
      addFunc={addItemFunction}
      breadCrumbs={[{ text: t(ETLCodes.CommissionParitaires), route: ERoutes.commissionParitaire }]}
    />
  );
};
